import { useDispatch, useSelector } from "react-redux";
import { deleteInactive } from "../features/transaction/transactionSlice";
import { deleteTransaction } from "../features/transaction/transactionThunk";

const DeleteModal = () => {
	const { deleting } = useSelector((state) => state.transaction);
	const dispatch = useDispatch();

	const handleDelete = () => {
		dispatch(deleteTransaction(deleting.id));
		dispatch(deleteInactive());
	};

	const handleCancel = () => {
		dispatch(deleteInactive());
	};

	return (
		<div className="absolute bg-black z-[500] h-screen w-full bg-opacity-50 flex justify-center items-center px-2">
			<div className="bg-white tracking-wide transition-opacity ease-in-out leading-loose md:max-w-2/5 h-fit p-4 md:p-6 space-y-6">
				<div className="space-y-4">
					<p className="text-lg font-medium">
						Do you Really want to Delete{" "}
						<span className="italic">{deleting.name}</span>?
					</p>
					<p className="leading-normal">
						Your action can not be undone. You can edit this insted.
					</p>
				</div>
				<div className="flex justify-end gap-2">
					<button
						onClick={handleDelete}
						className="px-4 py-1 md:py-2 bg-red-700 text-white rounded-lg"
					>
						Delete
					</button>
					<button
						onClick={handleCancel}
						className="px-4 py-1 md:py-2 bg-green-700 text-white rounded-lg"
					>
						Cancel
					</button>
				</div>
			</div>
		</div>
	);
};

export default DeleteModal;
